import { Alert, ColorProps, LoadingIcon } from 'localmed-core';
import * as React from 'react';
import {
  FontSizeProps,
  JustifyContentProps,
  SpaceProps,
  TextAlignProps,
  WidthProps,
} from 'styled-system';

type Props = ColorProps &
  FontSizeProps &
  JustifyContentProps &
  SpaceProps &
  TextAlignProps &
  WidthProps & {
    /** The content of the loading message. */
    children?: React.ReactNode;
  };

export default function LoadingMessage({ textColor = 'text', children = 'Loading…' }: Props) {
  return (
    <Alert textColor={textColor} icon={<LoadingIcon />} subtle>
      {children}
    </Alert>
  );
}
